export default __webpack_public_path__ + "static/media/dock-open.2b42fe21.svg";